import { bootstrapApplication } from '@angular/platform-browser';
import { App } from './app/app';
import { buildAppConfig } from './app/app.config';
import { AuthService } from './app/core/auth/auth.service';
import { CartSyncService } from './app/core/cart/cart-sync.service';
import { loadRuntimeConfig } from './app/core/runtime-config';

/**
 * La configuration est chargée avant le démarrage : l'application n'a jamais
 * d'état intermédiaire où l'URL de l'API ou les identifiants Cognito seraient
 * inconnus.
 */
async function bootstrap(): Promise<void> {
  const runtimeConfig = await loadRuntimeConfig();
  const app = await bootstrapApplication(App, buildAppConfig(runtimeConfig));
  // Restaure une session éventuellement présente en sessionStorage avant le
  // premier rendu utile, pour éviter un affichage « déconnecté » transitoire.
  await app.injector.get(AuthService).restoreSession();
  await app.injector.get(CartSyncService).bootstrap();
}

bootstrap().catch((error: unknown) => {
  console.error("Démarrage impossible de l'application", error);
  document.body.innerHTML =
    '<main style="font-family:system-ui;padding:2rem">' +
    '<h1>Application indisponible</h1>' +
    '<p>La configuration n’a pas pu être chargée. Réessayez dans un instant.</p>' +
    '</main>';
});
